
// ListarCompras.js

import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import LastPageIcon from '@mui/icons-material/LastPage';
//import Axios from 'axios';
import api from '../config/axiosConfig';


const ListarCompras = ({ handleSairListarClick, onCodcompraClick }) => {
  const [comprasDaPagina, setComprasDaPagina] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [orderBy, setOrderBy] = useState('nomefor'); // Estado para armazenar a ordenação selecionada
  const [filtroCodCompra, setFiltroCodCompra] = useState(''); // Estado para o código de compra
  const [isFiltrando, setIsFiltrando] = useState(false); // Controle para o filtro

  useEffect(() => {
    fetchCompras(currentPage, orderBy);
  }, [currentPage, orderBy]);


  const fetchCompras = async (page, order = 'nomefor') => {
    try {
      console.log(`Solicitando Compras da página ${page} ordenados por ${order}...`);
      const response = await api.get(`/compras/listarcompras/paginados?page=${page - 1}&size=10&sortBy=${order}`);

      setComprasDaPagina(response.data.content);
      setTotalPages(response.data.totalPages);
      console.log(`Compras da Página ${page} ordenados por ${order} carregados com sucesso:`, response.data.content);
    } catch (error) {
      console.error('Erro ao Carregar Compras:', error);
    }
  };


  const buscarPorCodCompra = async () => {
    try {
      if (filtroCodCompra.trim() === '') {
        alert('Por favor, insira um código de compra válido.');
        return;
      }
      console.log(`Buscando parcelas com código de compra: ${filtroCodCompra}`);
    const response = await api.get(`/compras/buscarcompra?codcompra=${filtroCodCompra}`);

    // Se a Compra foi encontrado (status 200)
    if (response.status === 200) {
      setComprasDaPagina([response.data]); // Coloca a Compra dentro de um array
      setIsFiltrando(true);
      setTotalPages(1); // Ajustar para evitar paginação em busca
    }
  } catch (error) {
    // Se o status for 404 (Fornecedor não encontrado)
    if (error.response && error.response.status === 404) {
      alert(`Nenhum Compra encontrado para o Código: ${filtroCodCompra}`);
      setComprasDaPagina([]); // Limpar a tabela
      setIsFiltrando(false); // Desativa o estado de filtragem
    } else {
      console.error('Erro ao buscar por código da Compra:', error);
      setComprasDaPagina([]); // Limpar a tabela em caso de outro Erro
      setIsFiltrando(false);
    }
  }
};

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleFirstPage = () => {
    setCurrentPage(1);
  };

  const handleLastPage = () => {
    setCurrentPage(totalPages);
  };
  

  const handleOrderByNome = () => {
    setOrderBy('nomefor');
    setCurrentPage(1); // Resetar para a primeira página ao mudar a ordenação
  };

  const handleOrderByCodigo = () => {
    setOrderBy('codcompra');
    setCurrentPage(1); // Resetar para a primeira página ao mudar a ordenação
  };


  return (
    <div>
      <Typography variant="h5" gutterBottom>Listagem de Compras</Typography>

      <Box display="flex" justifyContent="center" alignItems="center" mt={0}>
        <Typography variant="body1" style={{ marginTop: '0px', marginLeft: '20px' }}>
          Página {currentPage} de {totalPages}
        </Typography>

       {/* Botões de Navegação */}
        {!isFiltrando && (
          <Box>
            <ButtonGroup variant="contained" color="primary" style={{ height: '25px', padding: '0px 0px', marginLeft: '20px' }}>
              <Button onClick={handleFirstPage} disabled={currentPage === 1} style={{ color: 'inherit' }} startIcon={<FirstPageIcon />}></Button>
              <Button onClick={handlePreviousPage} disabled={currentPage === 1} style={{ color: 'inherit' }} startIcon={<NavigateBeforeIcon />}></Button>
              <Button onClick={handleNextPage} disabled={currentPage === totalPages} style={{ color: 'inherit' }} endIcon={<NavigateNextIcon />}></Button>
              <Button onClick={handleLastPage} disabled={currentPage === totalPages} style={{ color: 'inherit' }} endIcon={<LastPageIcon />}></Button>
            </ButtonGroup>
          </Box>
        )}

      </Box>


<Box display="flex" justifyContent="center" alignItems="center" mt={0}>
  {/* Botões de Ordenação e Busca */}
  <Box display="flex" justifyContent="center" alignItems="center" gap={2}>

    {/* Botões de Ordenação */}
    <Button
      variant="contained"
      color="secondary"
      style={{
        height: '25px',
        padding: '3px 6px',
        fontSize: '10px',
        fontFamily: 'Arial, sans-serif',
        fontWeight: 'bold'
      }}
      onClick={handleOrderByCodigo}
    >
      Lista Por Compra
    </Button>
    <Button
      variant="contained"
      color="secondary"
      style={{
        height: '25px',
        padding: '3px 6px',
        fontSize: '10px',
        fontFamily: 'Arial, sans-serif',
        fontWeight: 'bold'
      }}
      onClick={handleOrderByNome}
    >
      Por Fornecedor
    </Button>
         
    {/* Campo de Busca */}
    <input
      type="text"
      placeholder="Código Compra"
      value={filtroCodCompra}
      onChange={(e) => setFiltroCodCompra(e.target.value)}
      style={{
        padding: '5px',
        width: '100px',
        marginLeft: '30px',
        height: '25px',
        fontSize: '14px'
      }}
    />
    <Button
      variant="contained"
      color="primary"
      onClick={buscarPorCodCompra}
      style={{
        height: '25px',
        padding: '3px 6px',
        fontSize: '10px',
        fontFamily: 'Arial, sans-serif',
        fontWeight: 'bold'
      }}
    >
      Buscar
    </Button>          
          
    {/* Botão de Fechar à Direita */}
     <button
        type="button"
        className="btn-menu"
        onClick={handleSairListarClick}
        style={{ fontSize: '12px', fontWeight: 'bold', 
          height: '25px', padding: '3px 6px', marginLeft: '30px', width: '80px', color: 'inherit' }}
      >
        Fechar
      </button>
        
        </Box>
      </Box>


    <div style={{ overflowX: 'auto', margin: '20px' }}>
      <table style={{ textAlign: 'left', borderCollapse: 'collapse', width: '100%', minWidth: '800px' }}>

        <thead>
          <tr>
            <th style={{ padding: '10px', width: '80px' }}>Código</th>
            <th style={{ padding: '10px', width: '250px' }}>Fornecedor</th>
            <th style={{ padding: '10px', width: '200px' }}>CNPJ</th>
            <th style={{ padding: '10px', width: '150px' }} translate="no">Data Compra</th>
            <th style={{ padding: '10px', width: '150px' }}>Valor Compra</th>
          </tr>
        </thead>
        <tbody>
          {comprasDaPagina.map((compra) => (
            <tr key={compra.id}>
              <td style={{ padding: '10px', cursor: 'pointer', color: 'blue' }}
              onClick={() => onCodcompraClick(compra.codcompra)}>{compra.codcompra}</td>              
              <td style={{ padding: '10px' }} translate="no">{compra.nomefor}</td>
              <td style={{ padding: '10px' }}>{compra.cnpjfor}</td>
              <td style={{ padding: '10px' }}>{compra.dtcompra ? new
                Date(compra.dtcompra).toLocaleDateString('pt-BR') : 'Data não disponível'}</td>
              <td style={{ padding: '10px' }}>{compra.valcompra != null ?
                compra.valcompra.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : 'Valor não disponível'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>

  </div>
  );
};

export default ListarCompras;